import useWidgetHighlightingSync from './useWidgetHighlightingSync';
export default useWidgetHighlightingSync;